import { Directive, ElementRef, HostListener } from '@angular/core';
import { NgControl } from '@angular/forms';

export function canonicalPostalInput(value: string): string {
    const compact: string = value.toUpperCase().replace(/[^A-Z0-9]/g, '');
    if (!/^\d/.test(compact)) {
        return compact.slice(0, 6);
    }
    const digits: string = compact.replace(/\D/g, '').slice(0, 9);
    return digits.length > 5
        ? `${digits.slice(0, 5)}-${digits.slice(5)}`
        : digits;
}

@Directive({
    selector: '[postalCode]',
})
export class PostalCodeDirective {
    constructor(
        private el: ElementRef,
        private control: NgControl,
    ) {}

    @HostListener('input') onInput(): void {
        const postalCode: string = canonicalPostalInput(
            this.el.nativeElement.value,
        );
        this.el.nativeElement.value = postalCode;
        this.control.control?.setValue(postalCode);
    }
}
